export const AMBASSADORS_GET_PAYOUT = 'AMBASSADORS_GET_PAYOUT'
export const AMBASSADORS_SET_PAYOUT = 'AMBASSADORS_SET_PAYOUT'
export const AMBASSADORS_SET_PAYOUT_PROCESSING = 'AMBASSADORS_SET_PAYOUT_PROCESSING'

export const AMBASSADORS_GET_DETAILS = 'AMBASSADORS_GET_DETAILS'
export const AMBASSADORS_SET_DETAILS = 'AMBASSADORS_SET_DETAILS'
export const AMBASSADORS_SET_DETAILS_PROCESSING = 'AMBASSADORS_SET_DETAILS_PROCESSING'

export function getAmbassadorPayouts (payload) {
  return { type: AMBASSADORS_GET_PAYOUT, payload }
}

export function getAmbassadorDetails (payload) {
  return { type: AMBASSADORS_GET_DETAILS, payload }
}
